import { ArrowClockwise } from "@/components/ui/icons";
import { useElectronUpdater } from "@/hooks/use-electron-updater";
import { Button } from "@/components/ui/button";
import { LoadingIcon } from "@/components/ui/loading-icon";

export function SidebarUpdateBanner() {
  const { state, installNow } = useElectronUpdater();
  if (!state) return null;
  if (state.kind !== "downloaded" && state.kind !== "downloading") return null;

  if (state.kind === "downloading") {
    return (
      <div
        className="mx-2 mb-1 flex min-w-0 items-center gap-2 rounded-md bg-foreground/5 px-2.5 py-1.5 text-xs text-muted-foreground"
        title={`Downloading v${state.availableVersion} — ${Math.round(state.percent)}%`}
      >
        <LoadingIcon className="h-3 w-3 shrink-0" />
        <span className="min-w-0 flex-1 truncate">
          Updating… {Math.round(state.percent)}%
        </span>
      </div>
    );
  }

  return (
    <Button
      size="sm"
      onClick={installNow}
      title={`Relaunch Ano to install v${state.availableVersion}`}
      className="mx-2 mb-1 w-auto max-w-[calc(100%-1rem)] min-w-0 justify-start overflow-hidden"
    >
      <ArrowClockwise weight="Bold" className="shrink-0" />
      <span className="min-w-0 flex-1 truncate">Relaunch to update</span>
    </Button>
  );
}
